// Consent Mode v2 helpers. The gtag() function and default consent (denied)
// are defined in public/index.html.

export function grantConsent() {
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });
}

export function denyConsent() {
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
}

// Fires the Google Ads conversion (used on /gracias). No-op until the
// Google Ads ID + conversion label are filled in public/index.html.
export function trackConversion() {
  if (typeof window.gtag !== "function") return;
  const id = window.GOOGLE_ADS_ID;
  const label = window.GOOGLE_ADS_CONVERSION_LABEL;
  if (id && label) {
    window.gtag("event", "conversion", { send_to: `${id}/${label}` });
  }
}
